/*
 * Copyright (c) 2021.
 * This file is part of the Compo B2B application.
 * (c) Compo soft - Vladimir Ganturin <gun2rin@gmail.com>
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */

import {WidgetType} from './WidgetType';

export interface Widget {
  type: WidgetType;
  title: string;
  uri?: string;
  fullUri?: string;
  config?: any;
  visible: boolean;
}
